import React, { useState } from "react";
import { Button } from "@mui/material";
import { MdEdit } from "react-icons/md";
import AddGiftModal from "../../modal/AddGiftModal";

type Props = {
    gift: any;
    onGiftUpdated?: () => void;
};

const EditGift = ({ gift, onGiftUpdated }: Props) => {
    const [open, setOpen] = useState(false);

    const handleGiftUpdated = () => {
        onGiftUpdated?.();
        setOpen(false);
    };

    // Only show edit button if gift is not published
    if (gift?.is_published) {
        return null;
    }

    return (
        <>
            <Button
                variant="outlined"
                color="primary"
                size="small"
                startIcon={<MdEdit />}
                onClick={() => setOpen(true)}
                sx={{ minWidth: "fit-content" }}
            >
                تعديل
            </Button>
            <AddGiftModal
                open={open}
                setOpen={setOpen}
                onGiftAdded={handleGiftUpdated}
                gift={gift}
                isEdit={true}
            />
        </>
    );
};

export default EditGift;
